import React from 'react';
import { 
  Dialog, DialogTitle, DialogContent, DialogActions, 
  Button, CircularProgress, IconButton
} from '@mui/material';
import { X } from 'lucide-react';

const FormDialog = ({
  open,
  onClose,
  title,
  submitLabel = 'Save',
  cancelLabel = 'Cancel',
  onSubmit,
  isSubmitting = false,
  children,
  maxWidth = 'sm',
  isValid = true,
  fullWidth = true,
  customSubmitButton = null
}) => {
  return (
    <Dialog
      open={open}
      onClose={!isSubmitting ? onClose : undefined}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <DialogTitle className="flex items-center justify-between">
        <div>{title}</div>
        <IconButton onClick={onClose} size="small" disabled={isSubmitting}>
          <X className="w-5 h-5" />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {children}
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onClose}
          disabled={isSubmitting}
          color="inherit"
        >
          {cancelLabel}
        </Button>
        {customSubmitButton ? (
          React.cloneElement(customSubmitButton, {
            onClick: onSubmit,
            disabled: isSubmitting || !isValid
          })
        ) : (
          <Button
            onClick={onSubmit}
            variant="contained"
            color="primary"
            disabled={isSubmitting || !isValid}
            startIcon={isSubmitting ? <CircularProgress size={20} /> : null}
          >
            {submitLabel}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default FormDialog;
